/**
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base colors for the Material Kit 2 React.
 * You can add new color using this file.
 * You can customized the colors for the entire Material Kit 2 React using thie file.
 */

export default {
  background: {
    default: "#111111",
  },

  text: {
    main: "#4A4A4A",
    focus: "#4A4A4A",
  },

  transparent: {
    main: "transparent",
  },

  white: {
    main: "#EFE7DA",
    focus: "#F5F1E8",
  },

  black: {
    light: "#111111",
    main: "#000000",
    focus: "#000000",
  },

  primary: {
    main: "#C8A96B",
    focus: "#A88442",
  },

  secondary: {
    main: "#3A3A3A",
    focus: "#4A4A4A",
  },

  info: {
    main: "#C8A96B",
    focus: "#A88442",
  },

  success: {
    main: "#4CAF50",
    focus: "#67bb6a",
  },

  warning: {
    main: "#fb8c00",
    focus: "#fc9d26",
  },

  error: {
    main: "#6B1F1F",
    focus: "#8B2F2F",
  },

  light: {
    main: "#EFE7DA",
    focus: "#EFE7DA",
  },

  dark: {
    main: "#1C1C1C",
    focus: "#111111",
  },

  grey: {
    100: "#1C1C1C",
    200: "#2A2A2A",
    300: "#3A3A3A",
    400: "#4A4A4A",
    500: "#6B6B6B",
    600: "#8A8A8A",
    700: "#AAAAAA",
    800: "#CCCCCC",
    900: "#EFE7DA",
  },

  gradients: {
    primary: {
      main: "#C8A96B",
      state: "#A88442",
    },

    secondary: {
      main: "#3A3A3A",
      state: "#1C1C1C",
    },

    info: {
      main: "#C8A96B",
      state: "#A88442",
    },

    success: {
      main: "#66BB6A",
      state: "#43A047",
    },

    warning: {
      main: "#FFA726",
      state: "#FB8C00",
    },

    error: {
      main: "#6B1F1F",
      state: "#8B2F2F",
    },

    light: {
      main: "#EFE7DA",
      state: "#D6C7B2",
    },

    dark: {
      main: "#111111",
      state: "#1C1C1C",
    },
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86",
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec",
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d",
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c",
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22",
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a",
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2",
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874",
    },

    dribbble: {
      main: "#ea4c89",
      dark: "#e73177",
    },

    github: {
      main: "#24292e",
      dark: "#171a1d",
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00",
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749",
    },
  },

  badgeColors: {
    primary: {
      background: "#3A3A3A",
      text: "#C8A96B",
    },

    secondary: {
      background: "#3A3A3A",
      text: "#D6C7B2",
    },

    info: {
      background: "#3A3A3A",
      text: "#C8A96B",
    },

    success: {
      background: "#bce2be",
      text: "#339537",
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000",
    },

    error: {
      background: "#3A3A3A",
      text: "#6B1F1F",
    },

    light: {
      background: "#EFE7DA",
      text: "#1C1C1C",
    },

    dark: {
      background: "#111111",
      text: "#F5F1E8",
    },
  },

  coloredShadows: {
    primary: "#C8A96B",
    secondary: "#3A3A3A",
    info: "#C8A96B",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#6B1F1F",
    light: "#EFE7DA",
    dark: "#111111",
  },

  inputBorderColor: "#3A3A3A",

  tabs: {
    indicator: { boxShadow: "#C8A96B" },
  },
};
